import { render, staticRenderFns } from "./DashboardRestricted.vue?vue&type=template&id=1c143c40"
import script from "./DashboardRestricted.vue?vue&type=script&lang=ts"
export * from "./DashboardRestricted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports